module.exports = __webpack_public_path__ + "img/zdd_invite_feature_3.87daf0d8.png";